// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2FeQS","sendOtp":"AuthorizeToLogin_sendOtp__2Phmz"};